import React from 'react';
import ResultsSection from './ResultsSection';
import ProductOptions from './ProductOptions';
import PromptArea from './PromptArea';
import PromptButtons from './PromptButtons';
import Col from 'react-bootstrap/Col';
import Header from './Header';

const { title, content } = window.pageTemplateVariables || { title: null, content: null };

const MainContent = ({
    isLoading,
    activeImage,
    setActiveImage,
    activePrompt,
    imageUrls,
    selectedProduct,
    setSelectedProduct,
    textAreaValue,
    setTextAreaValue,
    promptButtonsData,
    isGenerateClickable,
    isConfirmClickable,
    handleGenerate,
    handleConfirm,
}) => {
    return (
        <div className="parent-container">
            <div className="left-column">
                <ResultsSection
                    isLoading={isLoading}
                    activeImage={activeImage}
                    setActiveImage={setActiveImage}
                    imageUrls={imageUrls}
                    activePrompt={activePrompt}
                />
            </div>
            <div className="right-column">
                <div className="header">
                    <Header title={title} content={content} />
                </div>
                <div className="subtext">
                    <ProductOptions
                        selectedProduct={selectedProduct}
                        setSelectedProduct={setSelectedProduct}
                    />
                    <PromptArea
                        textAreaValue={textAreaValue}
                        setTextAreaValue={setTextAreaValue}
                    />
                    <PromptButtons
                        promptButtonsData={promptButtonsData}
                        onButtonClick={setTextAreaValue}
                    />
                </div>
                <div className="form-controls">
                    <div className="button-section">
                        <button
                            className={`app-button large ${isGenerateClickable ? 'generate' : ''}`}
                            onClick={handleGenerate}
                            disabled={isLoading || !isGenerateClickable}
                        >
                            Bild generieren
                        </button>
                        <button
                            className={`app-button large ${isConfirmClickable ? 'continue' : ''}`}
                            onClick={handleConfirm}
                            disabled={!isConfirmClickable}
                        >
                            Jetzt kaufen
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MainContent;
